{
  "main": {
    "welcome": "Hello from {company}!",
    "appeal": "Write an appeal",
    "appeal_content": "Have anything to say? Create news through our Telegram bot!",
    "new_messages": "no messages | one message | {n} messages",
    "full_lang": {
      "en": "English",
      "ru": "Русский",
      "uz": "O'zbekcha",
      "uz-to": "Ўзбекча"
    },
    "short_lang": {
      "en": "En",
      "ru": "Ру",
      "uz": "O'z",
      "uz-to": "Ўз"
    },
    "live_stream": "Live Stream",
    "sum": "sum",
    "sections": "sections",
    "all": "all",
    "main": "main",
    "categories": "Categories",
    "contacts": "Contacts",
    "information": "Information",
    "more": "More",
    "return": "return",
    "read_also": "Read Also"
  },
  "footer": {
    "disclaimer_text": "Written consent is required to use the news on the site",
    "founder": "Founder",
    "certificate": "Certificate",
    "date_issued": "Date issued"
  },
  "search_bar": {
    "input_placeholder": "Search",
    "result": "Results on request",
    "result_not_first": "On request",
    "result_not": "nothing found",
    "sort_new": "New first",
    "sort_old": "Old first",
    "recomend": "Recommendations for you:"
  },
  "months": {
    "january": "January",
    "february": "February",
    "march": "March",
    "april": "April",
    "may": "May",
    "june": "June",
    "july": "July",
    "august": "August",
    "september": "September",
    "october": "October",
    "november": "November",
    "december": "December"
  },
  "days": {
    "today": "Today",
    "yesterday": "Yesterday",
    "0": "Sunday",
    "1": "Monday",
    "2": "Tuesday",
    "3": "Wednesday",
    "4": "Thursday",
    "5": "Friday",
    "6": "Saturday"
  },
  "video_player": {
    "volume": "Volume",
    "start_pauza": "Start/Pause",
    "mini_screen": "Mini player",
    "full_screen": "Wide screen",
    "back": "Return"
  },
  "not-found": {
    "not-found": "such page does not exist or has been deleted"
  },
  "error": {
    "error": "error",
    "search": "You can use the search to find the news you are interested in",
    "orback": "or return to the previous page",
    "input": "Search...",
    "nothing-found": "Nothing found"
  },
  "sayt_test": {
    "saytTest": "The site works in a test mode"
  },
  "routes": {
    "LiveStream": "Live Stream",
    "404": "Not Found",
    "Search": "Search",
    "SearchQuery": "Search {query}",
    "NewsDetail": "Zamon news",
    "FeedWrapper": "Feed Zamon news",
    "MainWrapper": "{category} Zamon news",
    "StaffDetail": "Staff Detail",
    "AccountSettings": "Account settings",
    "CreateArticles": "Create article",
    "EditArticle": "Edit article",
    "PreferredLang": "Create article",
    "Articles": "Articles",
    "StaffPage": "Zamon Team",
    "LogIn": "Log In",
    "Registration": "Registration",
    "Recovery": "Recovery"
  },
  "authorization": {
    "enter": "Enter",
    "registration": "Registration",
    "login": "Login",
    "password": "Password",
    "wronglogin": "* Invalid login",
    "wrongpassword": "* Invalid password",
    "forogtPassword": "Forgot your password?",
    "mainPage": "Go to the main page",
    "name": "name",
    "surname": "surname",
    "phone": "phone number",
    "email": "email",
    "realName": "Enter your real name",
    "realsurname": "Enter your real surname",
    "enterPhone": "Enter your phone number",
    "entermail": "Enter your mail",
    "continue": "continue",
    "emptyArea": "*This field is required",
    "newPassword": "Pick a password",
    "createNewPassword": "Come up with a new password",
    "replyNewPassword": "Repeat password ",
    "back": "Back",
    "needLogin": "You will need a login to log in",
    "passwordLength": "Password must contain at least six numbers, letters and punctuation marks",
    "busyLogin": "*Login 'Onegin' is busy",
    "showPassword": "*Password is too short‎‎",
    "passwordMismatch": "*Password mismatch",
    "infPassport": "Add passport photo",
    "contentPassport": "* The photo must be of good quality, without glare and shadows on the passport, with well-read information",
    "completeRegister": "Registration completed",
    "getImage": "Drag the image",
    "selectImage": "Select...",
    "imageFormat": "JPG, PNG",
    "image": "Image",
    "message": "After passing the validation, we will send to your E-mail a link to login to your personal account.",
    "validation": "Validation will take from 1 to 3 business days",
    "clear": "clear",
    "resetPassword": "Reset Password",
    "passwordRecovery": "Password recovery",
    "mailMessage": "Enter your email address below and we will send you an email with instructions on how to create a new password.",
    "yourMail": "your E-mail",
    "resetEmail": "*Enter the email address specified during registration",
    "instruction": "An email has been sent to your mail with instructions on how to create a new password",
    "saveChanges": "Save changes",
    "verifyTitle": "The confirmation code was sent via SMS to the number you specified during registration",
    "verification_code_invalid": "Verfication code invalid",
    "confirmCode": "Confirmation code",
    "repeatCode": "Send code again",
    "confirmCodeBtn": "Confirm Code",
    "humanPassportTitle": "Add a photo with an open passport as shown in the picture →",
    "explanation": "*The photo must be of good quality. Photos in sunglasses are not allowed, the face must be well lit",
    "overlay": "Complete registration"
  },
  "world": {
    "world_population": "World population"
  },
  "staff_page": {
    "count_news": "News",
    "count_views": "Views",
    "about_me": "About me",
    "last_news": "Last news:",
    "journalists": "Journalists",
    "employees": "Employees",
    "news_card": {
      "title": "В Ташкенте прошёл ежегодный фестиваль электронной музыки",
      "data": "08.05.2021, 22:57",
      "category": "Подкатегория"
    }
  },
  "header": {
    "new_news": "Create news",
    "auth": "Authorization",
    "appeal": "Write an appeal"
  },
  "news__detail": {
    "share": "share link",
    "share_facebook": "share on facebook",
    "share_instagram": "share on instagram",
    "share_telegram": "share on telegram",
    "share_title": "Share:",
    "tags_title": "Tags:"
  },
  "sport": {
    "math_started": "Match started"
  },
  "time": {
    "hour_ago": "hour",
    "minute_ago": "minute",
    "ago": "ago"
  },
  "uzbekistan": {
    "selectCountry": "Select a region to see its latest news:",
    "close": "Close",
    "karakalpakistan": "Republic of Karakalpakstan",
    "khorezm": "Khorezm region",
    "navoi": "Navoi region",
    "bukhara": "Bukhara region",
    "samarkand": "Samarkand region",
    "karshi": "Kashkadarya region",
    "jizzax": "Jizzakh region",
    "surkhandarya": "Surkhandarya region",
    "sirdarya": "Syrdarya region",
    "tashkent": "Tashkent",
    "namangan": "Namangan region",
    "fergana": "Fergana region",
    "andijan": "Andijan region"
  },
  "admin": {
    "admin": "Admin",
    "profile": "Editing a profile",
    "changepassword": "Change Password",
    "changed_profile": "Successful changed",
    "return": "Return",
    "username": "Name",
    "surname": "Surname",
    "userlogin": "Login",
    "usermail": "Email",
    "userbio": "About myself",
    "infbio": "Add information about yourself",
    "maxwords": "* Maximum 150 characters",
    "apply": "Apply",
    "currentpassword": "Enter your old password",
    "userpassword": "Enter a new password",
    "replypassword": "repeat new password",
    "length": "Password must contain at least eight numbers, letters and punctuation marks",
    "video": "This is a required field",
    "repeatable_fields": "title and subcategory exists",
    "title": "Creating news",
    "changeLang": "* To publish a news in Uzbek language, you need to write it in two versions - in Latin and Cyrillic",
    "prevLang": "Creating news on",
    "lang": "language",
    "latinlang": "Fill in",
    "latinlangOne": "the fields in",
    "latin": "Latin",
    "kr": "Cyrillic",
    "comment": "Please correct the errors below",
    "contentTitle": "Table of contents",
    "brief": "Brief",
    "description": "description",
    "media": "Video material:",
    "image": "Picture:",
    "atMoment": "At the moment:",
    "selectFile": "Select file",
    "delete": "delete",
    "tags": "Тags:",
    "avialable": "Available Tags",
    "selected": "Selected tags",
    "country": "choose a country",
    "regions": "choose a region",
    "selectedRegions": "selected region",
    "selectedCountry": "selected country",
    "regions_selected": "Select at least one region tag",
    "country_selected": "Select at least one country tag",
    "search": "Search",
    "filter": "Filter",
    "commandControl": "Hold Control (or Command on Mac) to select multiple values.",
    "selectAll": "Choose all",
    "removeAll": "delete all",
    "newsCategory": "News Category:",
    "status": "News status:",
    "draft": "Draft",
    "date": "Date of publication:",
    "explanationDate": "Дата и время когда будет опубликована новость",
    "editing": "Save and continue editing",
    "save": "Save",
    "addedNews": "News added",
    "views": "Total number of views",
    "add_news": " Add news",
    "go_out": "Log off",
    "home": "to the news",
    "changeIMage": "Change image",
    "published_news": "Published news",
    "moderation": "Pending Moderation",
    "rejected": "Rejected news",
    "drafts": "Drafts",
    "redactor": "Edit",
    "Go_to": "go over",
    "change_language": "Change language",
    "in_en": "In English",
    "in_ru": "In Russian",
    "in_uz": "In Uzbek",
    "choose_lang": "Choose in which language you will add news",
    "success_msg": "The news was successfully sent for moderation",
    "not_published": "You have no published news in the selected language",
    "mediaToTg": "Media in Telegram",
    "msgToTg": "Message in Telegram",
    "videoToTg": "Video in Telegram"
  },
  "super_user": {
    "title": "Select news for changes",
    "set_page": "Go to",
    "news_count": "News",
    "search": "Find",
    "filter": "Filter",
    "id": "ID",
    "news_title": "TABLE OF CONTENTS",
    "news_author": "NEWS AUTHOR",
    "news_category": "CATEGORY NEWS",
    "news_date": "DATE OF PUBLICATION",
    "news_status": "STATUS NEWS",
    "draft": "DRAFT",
    "move": "shown",
    "from": "from",
    "clear": "clear all filters",
    "from_date": "from the date of",
    "to_date": "By date",
    "reset": "Reset",
    "all": "All",
    "yes": "Yes",
    "no": "No"
  }
}